'use client';

import { useState, useEffect } from 'react';

// ----------------------------------------------------------------------

/** 첫 화면의 단추 묶음 `id` — 이것이 화면 밖으로 나가야 아래 고정 단추가 선다 */
export const HOME_HERO_CTA_ID = 'home-hero-cta';
/** 맨 아래 체험 구역 `id` — 이것이 보이면 고정 단추를 내린다(같은 단추가 두 번 서지 않게) */
export const HOME_FINAL_CTA_ID = 'cta';

/**
 * 폰 아래 고정 「무료로 시작하기」를 세울 때인가.
 *
 * 🔑 첫 화면의 단추가 보이는 동안은 안 선다 — 같은 단추가 겹쳐 보이고 시연 영상을 가린다.
 * 🔑 맨 아래 체험 구역이 보이면 내린다.
 * ⚠️ `IntersectionObserver` 가 없으면 끝까지 안 선다(첫 화면 단추와 맨 아래 단추는 그대로 있다).
 */
export function useHomeStickyCta(): boolean {
  const [heroOut, setHeroOut] = useState(false);
  const [finalIn, setFinalIn] = useState(false);

  useEffect(() => {
    if (typeof IntersectionObserver === 'undefined') return undefined;
    const hero = document.getElementById(HOME_HERO_CTA_ID);
    const final = document.getElementById(HOME_FINAL_CTA_ID);
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.target === hero) setHeroOut(!entry.isIntersecting && entry.boundingClientRect.top < 0);
        if (entry.target === final) setFinalIn(entry.isIntersecting);
      });
    });
    if (hero) observer.observe(hero);
    if (final) observer.observe(final);
    return () => observer.disconnect();
  }, []);

  return heroOut && !finalIn;
}
